/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Popper, Fade, Paper, Typography, Divider, IconButton, Tooltip, List, ListItem, ListItemText, ListItemSecondaryAction, ClickAwayListener } from '@material-ui/core'
import { Refresh, Add, ArrowRight } from '@material-ui/icons'

import Actions from '../../../../../../fluid/Actions/ActionFactory'

import CreateEvent from '../../../../../Events/components/CreateEvent'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});

const styles = theme => ({

})

class EventList extends Component {
    state = {
        events : null,
        getting_events : false,
        events_error : false,
        add_event : false,
        event_state : null,
        event_obj : null,
        openPopper: true
    }

    componentDidMount () {
        this.getEvents()
    }

    getEvents = () => {
        this.setState({
            ...this.state,
            getting_events : true
        }, () => {
            Actions("http_request", {
                url : "/sainapse/event_group/" + this.props.event_group_name + "/event",
                method : "get",
                data : {}
            }).then(res => {
                this.setState({
                    ...this.state,
                    events : res.data.result,
                    getting_events : false,
                    events_error : false
                })
            }).catch(err => {
                this.setState({
                    ...this.state,
                    events : null,
                    getting_events : false,
                    events_error : true
                })
            })
        })
    }

    renderEventsListBox = () => {
        if (this.state.getting_events) {
            return (
                <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography color = 'textSecondary'><em>Getting Events...</em></Typography>
                </div>
            )
        } else {
            if (this.state.events !== null) {
                if (this.state.events.length === 0) {
                    return (
                        <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography color = 'textSecondary'><em>No Events Registered.</em></Typography>
                        </div>
                    )
                } else {
                    return (
                        <List>
                            {this.renderEventsList()}
                        </List>
                    )
                }
            } else {
                if (this.state.events_err) {
                    return (
                        <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography variant = 'caption' color = 'secondary'><em>Error retreiving Events.</em></Typography>
                        </div>
                    )
                }
            }
        }
    }

    renderEventsList = () => {
        
        let events = this.state.events.map((ev, i) => {
            return (
                <ListItem key = {i} dense button onClick = {() => this.pushEvent(ev.name)}>
                    <ListItemText  primary = {ev.name}/>
                </ListItem>
            )
        })

        return events
    }

    pushEvent = (event_name) => {
        this.props.push_event(event_name)
    }

    closeDialog = () => {
        this.setState({
            ...this.state,
            add_event : false,
            event_state : null,
            event_obj : null
        }, () => this.getEvents())
    }

    openEventDialog = (event_state, event_obj) => {
        this.setState({ ...this.state, openPopper: false} , () => {
            this.setState({
                ...this.state,
                add_event : true,
                event_state : event_state,
                event_obj : event_obj
            })
        })
        
    }

    renderCreateEvent = () => {
        if (this.state.add_event) {
            return (
                <CreateEvent
                    zIndex = "20000" 
                    open = {this.state.add_event} 
                    close = {this.closeDialog} 
                    event_state = {this.state.event_state} 
                    event_obj = {this.state.event_obj}
                    event_group = {this.props.event_group_name}
                />
            )
        }
    }

    handleClickAway = () => {
        this.setState({ openPopper: false })
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <Popper
                    style = {{zIndex : "10000"}}
                    id = "event-list" 
                    open = {this.state.openPopper} 
                    anchorEl={this.props.anchorEl} 
                    transition
                    placement="right-start"
                    disablePortal={false}
                    modifiers={{
                        flip: {
                            enabled: true,
                        },
                        // preventOverflow: {
                        //     enabled: true,
                        //     boundariesElement: 'scrollParent',
                        // }
                    }}
                >
                    {({ TransitionProps }) => (
                        <ClickAwayListener onClickAway={  this.handleClickAway }  >
                        <Fade {...TransitionProps} timeout={350}>
                            <Paper elevation = {5} style = {{width : '300px', height : '300px', display : 'flex', flexDirection : 'column'}}>
                                <div style = {{padding : '10px', display : 'flex', flexDirection : 'row', borderBottom : '1px solid rgba(0,0,0,0.12)', alignItems : 'center'}}>
                                    <Typography PopperProps = {{style : {zIndex : '10000'}}} style = {{flexGrow : 1}} variant = 'subtitle2' color = 'textSecondary'>Events</Typography>
                                    <Tooltip title = "Add Event Group">
                                        <IconButton style = {{marginRight : '5px'}} size = 'small' color = 'primary' onClick = {() => this.openEventDialog('create', {})}>
                                            <Add fontSize = 'small'/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip PopperProps = {{style : {zIndex : '10000'}}} title = "Refresh">
                                        <IconButton size = 'small' color = 'primary' onClick = {this.getEvents}>
                                            <Refresh fontSize = 'small'/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div style = {{flexGrow : 1, overflow: 'auto'}}>
                                    {this.renderEventsListBox()}
                                </div>
                            </Paper> 
                        </Fade>
                        </ClickAwayListener>
                    )}
                </Popper>
                {this.renderCreateEvent()}
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(EventList);